import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { AuthShell } from "../components/AuthShell";
import { PhotoDrop } from "../components/PhotoDrop";
import { useAuth } from "../context/AuthContext";
import { errMsg, CATS } from "../lib/api";

const IMG = "https://images.unsplash.com/photo-1597019558926-3eef445fdf60?auto=format&fit=crop&w=1400&q=80";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", title: "", category: "futebol" });
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target ? e.target.value : e });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (file) fd.append("photo", file);
    try {
      await register(fd);
      toast.success(file ? "Conta criada e foto grátis enviada para análise!" : "Conta criada! Você ainda tem 1 foto grátis.");
      nav("/painel");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Cadastro" kicker="// Entre na arena" image={IMG}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="flex items-center gap-3 rounded-xl border border-lime-400/30 bg-lime-400/5 p-4" data-testid="register-free-photo-notice">
          <Gift className="h-6 w-6 shrink-0 text-lime-300" />
          <p className="text-sm text-slate-300"><b className="text-lime-300">1 foto grátis</b> no cadastro. Fotos extras são pagas e liberam os concursos principais.</p>
        </div>
        <div className="space-y-1.5">
          <Label>Nome</Label>
          <Input data-testid="register-name-input" required value={form.name} onChange={set("name")} />
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-1.5">
            <Label>E-mail</Label>
            <Input data-testid="register-email-input" type="email" required value={form.email} onChange={set("email")} />
          </div>
          <div className="space-y-1.5">
            <Label>Senha</Label>
            <Input data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={set("password")} />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label>Sua foto grátis (opcional agora)</Label>
          <PhotoDrop file={file} onChange={setFile} testId="btn-upload-free-photo" />
        </div>
        {file && (
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-1.5">
              <Label>Título da foto</Label>
              <Input data-testid="register-photo-title-input" value={form.title} onChange={set("title")} placeholder="Ex: Gol no último minuto" />
            </div>
            <div className="space-y-1.5">
              <Label>Modalidade</Label>
              <Select value={form.category} onValueChange={set("category")}>
                <SelectTrigger data-testid="register-category-select"><SelectValue /></SelectTrigger>
                <SelectContent>{CATS.map((c) => <SelectItem key={c.slug} value={c.slug}>{c.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </div>
        )}
        {error && <p data-testid="register-error" className="text-sm text-red-400">{error}</p>}
        <button data-testid="register-submit-btn" disabled={loading} className="btn-neon flex w-full items-center justify-center gap-2 rounded-full py-3.5 font-semibold disabled:opacity-50">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Criar conta
        </button>
        <p className="text-center text-sm text-slate-400">
          Já tem conta? <Link to="/entrar" data-testid="register-to-login-link" className="text-cyan-300 hover:underline">Entrar</Link>
        </p>
      </form>
    </AuthShell>
  );
}
